import React, { useEffect } from "react";
import { VStack, Box, useBreakpointValue } from "@chakra-ui/react";
import { VerifyEmail } from "../Components/custom/VerifyEmail";
import { Stepper } from "../Components/custom/Stepper";
import { getDomainConfig } from "../Utils/dynamicBranding";

export const EmailVerification = () => {
  useEffect(() => {
    // Set page title dynamically based on domain
    const config = getDomainConfig();
    document.title = `Email Verification - ${config.title}`;
  }, []);
  
  // Responsive padding values
  const pagePaddingX = useBreakpointValue({ base: 3, sm: 4, md: 6 });
  const pagePaddingTop = useBreakpointValue({ base: 2, sm: 3, md: 4 });
  
  return (
    <VStack 
      height="100vh" 
      paddingTop={pagePaddingTop}
      paddingX={pagePaddingX}
      width="100%"
      overflowX="hidden"
      spacing={4}
    >
      <Box width="100%" maxWidth="100%">
        <Stepper currentStep={1} />
      </Box>
      <Box width="100%" maxWidth="100%" flex="1">
        <VerifyEmail />
      </Box>
    </VStack>
  );
};